// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
//////////////////////////////////////////////////////////////////////////////////////////////

import { DoubleMatrix, ExpandDoubleVector } from "./DoubleMatrix.js";
import { LevelLine } from "./LevelLine.js";

export let CloudVector = function (count, firstLineColor, secondLineColor, gradientMethod)
{
    DoubleMatrix.call(this);
    this.FFirstLineColor = firstLineColor;
    this.FSecondLineColor = secondLineColor;
    this.FGradientMethod = gradientMethod;
    this.FArray = new ExpandDoubleVector();
    this.FArray[0] = new ExpandDoubleVector(count, 0);
    this.FArray[1] = new ExpandDoubleVector(count, 0);

    this.FArray[0].Shift = 0;
    this.FArray[1].Shift = 0;
}
CloudVector.prototype = Object.create(DoubleMatrix.prototype)

Object.defineProperty(CloudVector.prototype, "GRADIENT_NONE",
    {
        get: function () { return 0; }
    });

Object.defineProperty(CloudVector.prototype, "GRADIENT_SIMPLE",
    {
        get: function () { return 1; }
    });

Object.defineProperty(CloudVector.prototype, "GRADIENT_LENEAR",
    {
        get: function () { return 2; }
    });

Object.defineProperty(LevelLine.prototype, "FirstLineColor",
    {
        get: function () { return this.FFirstLineColor; },
        set: function (value)
        {
            this.FFirstLineColor = value;
        }
    });

Object.defineProperty(CloudVector.prototype, "SecondLineColor",
    {
        get: function () { return this.FSecondLineColor; },
        set: function (value)
        {
            this.FSecondLineColor = value;
        }
    });

Object.defineProperty(CloudVector.prototype, "GradientMethod",
    {
        get: function () { return this.FGradientMethod; },
        set: function (value)
        {
            this.FGradientMethod = value;
        }
    });

CloudVector.prototype.Add = function (value)
{
    this.FArray[0].Add(value);
    this.FArray[1].Add(value);
};

CloudVector.prototype.Get = function (index)
{
    return this.FArray[index];
};

Object.defineProperty(CloudVector.prototype, "Shift",
    {
        get: function () { return this.FArray[0].Shift || 0 },
        set: function (value) { this.FArray[0].Shift = this.FArray[1].Shift = (value || 0) }
    });